import Hero from "../components/Hero";
import VideoCards from "../components/VideoCards";

function Home() {
  return (
    <>
      <Hero />
      <VideoCards />
    </>
  );
}

export default Home;